import $ from 'jquery';
import ApexCharts from 'apexcharts';

$(function () {
    const $container = $('#rent-vs-buy-app');
    if (!$container.length) return;

    let currency = $container.data('currency') || 'USD';
    let symbol = currency === 'USD' ? '$' : currency === 'EUR' ? '€' : currency === 'PLN' ? 'zł' : '₴';
    let chartInstance = null;

    const textMoreCurrencies = $container.data('text-more-currencies') || 'Ще валюти';
    const textMoreShort = $container.data('text-more-short') || 'Ще';

    const $initBtn = $('#rent-currency-tabs button.active');
    if ($initBtn.length) {
        currency = $initBtn.data('currency-code') || currency;
        symbol = $initBtn.data('symbol') || symbol;
    }

    const culture = $container.data('culture') || 'uk-UA';
    const localeMap = { 'uk': 'uk-UA', 'pl': 'pl-PL', 'de': 'de-DE', 'es': 'es-ES', 'it': 'it-IT', 'en': 'en-US' };
    const dateLocale = localeMap[culture] || 'en-US';

    const seriesBuyer = $container.data('series-buyer') || 'Капітал у житлі (Equity)';
    const seriesRenter = $container.data('series-renter') || 'Портфель інвестора (ETF)';
    const unitYears = $container.data('unit-years') || 'р.';
    const unitPerMonth = $container.data('unit-per-month') || '/ міс';
    const winnerBuyer = $container.data('winner-buyer') || 'Купівля';
    const winnerRenter = $container.data('winner-renter') || 'Оренда';
    const investDelta = $container.data('invest-delta') || 'інвест';

    const $priceRange = $('#rent-price-range');
    const $priceDisplay = $('#rent-price-display');

    const $downRange = $('#rent-down-range');
    const $downDisplay = $('#rent-down-display');

    const $rateRange = $('#rent-mortgage-rate-range');
    const $rateDisplay = $('#rent-mortgage-rate-display');

    const $termRange = $('#rent-mortgage-term-range');
    const $termDisplay = $('#rent-mortgage-term-display');

    const $rentRange = $('#rent-monthly-rent-range');
    const $rentDisplay = $('#rent-monthly-rent-display');

    const $returnRange = $('#rent-investment-return-range');
    const $returnDisplay = $('#rent-investment-return-display');

    const $apprRange = $('#rent-appreciation-range');
    const $apprDisplay = $('#rent-appreciation-display');

    function formatMoney(num) {
        return Math.round(num).toLocaleString(dateLocale) + ' ' + symbol;
    }

    function calculate() {
        const homePrice = parseFloat($priceRange.val()) || 80000;
        const downPct = (parseFloat($downRange.val()) || 20) / 100;
        const downAmount = homePrice * downPct;
        const mortgageRate = (parseFloat($rateRange.val()) || 7.0) / 100;
        const mortgageTerm = parseInt($termRange.val(), 10) || 20;
        const monthlyRent = parseFloat($rentRange.val()) || 550;
        const investReturn = (parseFloat($returnRange.val()) || 8.5) / 100;
        const homeAppr = (parseFloat($apprRange.val()) || 3.5) / 100;

        $priceDisplay.text(formatMoney(homePrice));
        $downDisplay.text((downPct * 100).toFixed(0) + '% (' + formatMoney(downAmount) + ')');
        $rateDisplay.text((mortgageRate * 100).toFixed(1) + '%');
        $termDisplay.text(mortgageTerm + ' ' + unitYears);
        $rentDisplay.text(formatMoney(monthlyRent) + ' ' + unitPerMonth);
        $returnDisplay.text((investReturn * 100).toFixed(1) + '%');
        $apprDisplay.text((homeAppr * 100).toFixed(1) + '%');

        // Mortgage payment formula
        const principal = homePrice - downAmount;
        const monthlyRate = mortgageRate / 12;
        const totalMonths = mortgageTerm * 12;

        let monthlyMortgage = 0;
        if (monthlyRate > 0) {
            monthlyMortgage = principal * (monthlyRate * Math.pow(1 + monthlyRate, totalMonths)) / (Math.pow(1 + monthlyRate, totalMonths) - 1);
        } else {
            monthlyMortgage = principal / totalMonths;
        }

        const monthlyMaintenance = (homePrice * 0.01) / 12;
        const totalBuyerMonthly = monthlyMortgage + monthlyMaintenance;

        $('#rent-monthly-buyer-outlay').text(formatMoney(totalBuyerMonthly) + ' ' + unitPerMonth);
        $('#rent-monthly-renter-outlay').text(formatMoney(monthlyRent) + ' ' + unitPerMonth + ' (+ ' + investDelta + ')');

        // 20-year simulation
        const years = 20;
        const labels = ['0 ' + unitYears];
        const buyerEquityData = [Math.round(downAmount)];
        const renterPortfolioData = [Math.round(downAmount)];

        let currentHomeVal = homePrice;
        let remainingLoan = principal;
        let renterPortfolio = downAmount;
        let currentRent = monthlyRent;
        let breakevenYear = null;

        for (let y = 1; y <= years; y++) {
            // Buyer year progress
            for (let m = 1; m <= 12; m++) {
                if (remainingLoan > 0) {
                    const interestPayment = remainingLoan * monthlyRate;
                    const principalPayment = Math.min(remainingLoan, monthlyMortgage - interestPayment);
                    remainingLoan -= principalPayment;
                }
            }
            currentHomeVal = currentHomeVal * (1 + homeAppr);
            const buyerEquity = Math.max(0, currentHomeVal - Math.max(0, remainingLoan));

            // Renter year progress
            for (let m = 1; m <= 12; m++) {
                const diff = totalBuyerMonthly - currentRent;
                renterPortfolio = (renterPortfolio + diff) * (1 + investReturn / 12);
            }
            currentRent = currentRent * 1.025; // 2.5% rent inflation

            buyerEquityData.push(Math.round(buyerEquity));
            renterPortfolioData.push(Math.round(renterPortfolio));
            labels.push(y + ' ' + unitYears);

            if (breakevenYear === null && buyerEquity >= renterPortfolio && y >= 2) {
                breakevenYear = y;
            }
        }

        const finalBuyer = buyerEquityData[buyerEquityData.length - 1];
        const finalRenter = renterPortfolioData[renterPortfolioData.length - 1];

        $('#rent-kpi-equity').text(formatMoney(finalBuyer));
        $('#rent-kpi-portfolio').text(formatMoney(finalRenter));

        if (breakevenYear !== null) {
            $('#rent-kpi-breakeven').text(breakevenYear + ' ' + unitYears);
        } else {
            $('#rent-kpi-breakeven').text('> 20 ' + unitYears);
        }

        if (finalBuyer >= finalRenter) {
            const diff = finalBuyer - finalRenter;
            $('#rent-kpi-winner').text(winnerBuyer + ' (+' + formatMoney(diff) + ')').removeClass('text-success').addClass('text-primary');
        } else {
            const diff = finalRenter - finalBuyer;
            $('#rent-kpi-winner').text(winnerRenter + ' (+' + formatMoney(diff) + ')').removeClass('text-primary').addClass('text-success');
        }

        renderChart(labels, buyerEquityData, renterPortfolioData);
    }

    function renderChart(labels, buyerData, renterData) {
        const isDark = $('body').hasClass('dark') || $('body').attr('data-layout-mode') === 'dark';

        const options = {
            series: [
                { name: seriesBuyer, data: buyerData },
                { name: seriesRenter, data: renterData }
            ],
            chart: {
                type: 'line',
                height: 280,
                toolbar: { show: false },
                animations: { enabled: true, speed: 400 }
            },
            colors: ['#556ee6', '#34c38f'],
            stroke: {
                curve: 'smooth',
                width: [3, 3]
            },
            dataLabels: { enabled: false },
            xaxis: {
                categories: labels,
                labels: { style: { colors: isDark ? '#a6b0cf' : '#74788d' } }
            },
            yaxis: {
                labels: {
                    formatter: function (val) {
                        if (val >= 1000000) return (val / 1000000).toFixed(1) + 'M ' + symbol;
                        if (val >= 1000) return (val / 1000).toFixed(0) + 'k ' + symbol;
                        return val + ' ' + symbol;
                    },
                    style: { colors: isDark ? '#a6b0cf' : '#74788d' }
                }
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return formatMoney(val);
                    }
                }
            },
            legend: {
                position: 'top',
                horizontalAlign: 'right',
                labels: { colors: isDark ? '#a6b0cf' : '#74788d' }
            },
            grid: {
                borderColor: isDark ? '#32394e' : '#f1f1f1'
            }
        };

        const chartEl = document.querySelector('#rent-vs-buy-chart');
        if (!chartEl) return;

        if (chartInstance) {
            chartInstance.updateOptions(options);
        } else {
            chartInstance = new ApexCharts(chartEl, options);
            chartInstance.render();
        }
    }

    // Input listeners
    $priceRange.add($downRange).add($rateRange).add($termRange).add($rentRange).add($returnRange).add($apprRange).on('input', calculate);

    // Currency Switcher
    function setRentCurrency(btn, isDropdown) {
        currency = $(btn).data('currency-code');
        symbol = $(btn).data('symbol') || '$';

        if (isDropdown) {
            $('#rent-currency-tabs > button[data-currency-code]').removeClass('active');
            $('.rent-currency-dropdown-item').removeClass('active');
            $(btn).addClass('active');
            $('.rent-more-currencies-btn').addClass('active');
            $('#rent-active-custom-currency').text(`${symbol} ${currency}`);
        } else {
            $('#rent-currency-tabs button').removeClass('active');
            $(btn).addClass('active');
            $('.rent-more-currencies-btn').removeClass('active');
            $('.rent-currency-dropdown-item').removeClass('active');
            $('#rent-active-custom-currency').html(`
                <span class="d-none d-sm-inline">${textMoreCurrencies}</span>
                <span class="d-sm-none">${textMoreShort}</span>
            `);
        }

        const defPrice = parseFloat($(btn).data('price')) || 80000;
        const defRent = parseFloat($(btn).data('rent')) || 550;
        const defRate = parseFloat($(btn).data('rate')) || 7.0;
        const defReturn = parseFloat($(btn).data('return')) || 8.5;

        $priceRange.val(defPrice);
        $rentRange.val(defRent);
        $rateRange.val(defRate);
        $returnRange.val(defReturn);

        if (currency === 'UAH' || currency === 'CZK') {
            $priceRange.attr({ min: 500000, max: 10000000, step: 100000 });
            $rentRange.attr({ min: 5000, max: 100000, step: 1000 });
        } else if (currency === 'PLN') {
            $priceRange.attr({ min: 100000, max: 2000000, step: 25000 });
            $rentRange.attr({ min: 1000, max: 20000, step: 200 });
        } else {
            $priceRange.attr({ min: 20000, max: 400000, step: 5000 });
            $rentRange.attr({ min: 100, max: 3000, step: 25 });
        }

        calculate();
    }

    $('#rent-currency-tabs > button[data-currency-code]').on('click', function () {
        setRentCurrency(this, false);
    });

    $(document).on('click', '.rent-currency-dropdown-item', function (e) {
        e.preventDefault();
        setRentCurrency(this, true);
    });

    calculate();
});

